module.exports = __webpack_public_path__ + "static/media/Nessus-logo.d8470675.png";